import { CircledIcon } from 'prove-common'

type TimelineProps = {
  icon: React.ReactNode
  showLine: boolean
  classNameIcon?: string
  label?: string
}

export const Timeline = ({
  showLine = true,
  icon,
  classNameIcon,
  label,
  ...props
}: TimelineProps) => (
  <div className='flex flex-col items-center gap-1 self-stretch' {...props}>
    <CircledIcon icon={icon} className={classNameIcon} label={label} />
    {showLine && <div className='h-full bg-border-subtle w-[1px]' />}
  </div>
)
